import { HeaderPanel } from '../HeaderPanel';
import { AttachmentsPanelContent } from './components/AttachmentsPanelContent';

import styles from './AttachmentsPanel.module.scss';

type Props = { expanded: boolean; onClose: () => void };

export const AttachmentsPanel: React.FC<Props> = ({ expanded, onClose }) => {
  return (
    <div className={styles.panelContainer}>
      <HeaderPanel expanded={expanded} onClose={onClose} title={'menu.attachments'} />
      {expanded && <AttachmentsPanelContent />}
    </div>
  );
};
